import jwt_decode, { JwtPayload } from 'jwt-decode';

import { HeaderKey } from '../../services/authorization.service';

type AuthTokenPayload = JwtPayload & {
  applicant_id?: string;
};

let timeoutId: ReturnType<typeof setTimeout> | null = null;

const getAuthToken = (): string | null => {
  return localStorage.getItem(HeaderKey.AuthToken);
};

const decodeAuthToken = (authToken: string): AuthTokenPayload => {
  return jwt_decode<AuthTokenPayload>(authToken);
};

const getApplicantIdFromAuthToken = (): string | null => {
  const authToken = getAuthToken();
  if (!authToken) return null;
  return decodeAuthToken(authToken).applicant_id ?? null;
};

// logout: called when the token expires while the app is actively in use (timeout fires mid-session).
// discardExpired: called when the token is already expired on cold load — silently discard, no error shown.
const setExpiredAuthCallback = (logout: () => void, discardExpired: () => void): void => {
  const authToken = getAuthToken();

  if (authToken) {
    const decoded = decodeAuthToken(authToken);
    const exp = decoded.exp! * 1000;
    const timeLeft = exp - Date.now();
    if (timeLeft <= 0) {
      discardExpired();
    } else {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        logout();
      }, timeLeft);
    }
  }
};

export { setExpiredAuthCallback, getApplicantIdFromAuthToken };
